/**
 * a random delay to avoid network congestion
 * @returns {number} - a random number between 800 and 1800
 * @see {@link https://pt.wikipedia.org/wiki/Jitter}
 */
export function delayWithJitter () {
  return Math.round(Math.random() * 1000) + 800
}

/**
 * create a delay in promise format.
 * An alternative to using callback functions
 * @param {number} time - delay time
 * @returns {Promise<void>}
 */
export function promiseDelay (time = delayWithJitter()) {
  return new Promise(resolve => setTimeout(resolve, time))
}
